import React from "react";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import DashboardMainContent from "./DashboardMainContent";

const DashboardRequestContent = () => {
  return (
    <div className="main-content-wrapper">
      <DashboardMainContent
        className="content-box"
        iconImage={faUserPlus}
        navigationLinkLable="CT Scan"
        stateKey="ctscandashboard"
      />
    </div>
  );
};

export default DashboardRequestContent;
